import React, { Fragment } from 'react';
import SvgIcon from 'src/react_components/svg-icon';

type Partner = {
  clientName: string;
  slug: string;
  logo: string | null;
  url: string;
};

interface PartnerListProps {
  partners: Partner[];
  currentPage: number;
  totalPages: number;
  loadedImages: Set<string>;
  onPageChange: (page: number) => void;
  onImageLoad: (slug: string) => void;
}

const PartnerList = ({
  partners,
  currentPage,
  totalPages,
  loadedImages,
  onPageChange,
  onImageLoad
}: PartnerListProps) => (
  <Fragment>
    <div className="container d-flex flex-column">
      <div className="row">
        {partners.map((partner) => (
          <div key={partner.slug} className="col-12 col-md-6 mb-4">
            <a
              key={partner.slug}
              href={partner.url}
              target="_blank"
              className="d-flex align-items-center gap-2 rounded-2 shadow-sm p-3
                  border border-1 border-light h-100 bg-white"
              rel="noopener noreferrer"
            >
              {partner.logo ? (
                <Fragment>
                  <img
                    src={partner.logo}
                    alt={`${partner.clientName} logo`}
                    className="partner-logo"
                    onLoad={() => onImageLoad(partner.slug)}
                  />
                  {!loadedImages.has(partner.slug) && (
                    <SvgIcon icon="spinner" className="icon-spin" />
                  )}
                  <span className="partner-details">
                    {partner.clientName}
                  </span>
                </Fragment>
              ) : (
                <span>
                  {partner.clientName}
                </span>
              )}
            </a>
          </div>
        ))}
      </div>
    </div>

    <nav
      id="partner-pagination"
      className="d-flex gap-2 justify-content-center"
    >
      {totalPages > 1 && (
        <ul className="pagination justify-content-center gap-2">
          <li className="page-item d-flex align-items-center justify-content-center">
            <button
              type="button"
              className="page-link bg-transparent border-0"
              disabled={currentPage === 1}
              onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
            >
              <SvgIcon icon="chevron-left" className="m-0" />
            </button>
          </li>

          {[...Array(totalPages).keys()].map((page) => (
            <li
              key={page + 1}
              className={[
                'page-item d-flex align-items-center justify-content-center',
                currentPage === page + 1 && 'active'].filter(Boolean).join(' ')}
            >
              <button
                type="button"
                className="page-link"
                onClick={() => onPageChange(page + 1)}
              >
                {page + 1}
              </button>
            </li>
          ))}

          <li className="page-item d-flex align-items-center justify-content-center">
            <button
              type="button"
              className="page-link bg-transparent border-0"
              disabled={currentPage === totalPages}
              onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))}
            >
              <SvgIcon icon="chevron-right" className="m-0" />
            </button>
          </li>
        </ul>
      )}
    </nav>
  </Fragment>
);

export default PartnerList;
